import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../Header";
import Footer from "../Footer";
import config from '../../config';
import SearchComponent from '../matching/SearchComponent';
import PopupService from '../PopupService';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/ApiFetch';
import { useApi } from '../../ApiContext';
function FinalReview() {
	const location = useLocation();
	const navigate = useNavigate(); //

	const { batchMatchId, clientId, matchResultId, bigMatchResult: initialBigMatchResult } = location.state || {};
	const [bigMatchResult, setBigMatchResult] = useState(initialBigMatchResult || null);

	const sessionuser = sessionStorage.getItem('username');
	const username = sessionStorage.getItem("username");
	const mrToken = localStorage.getItem("mr_token");
	const batchMatchIdRef = useRef(batchMatchId);
	const [selectedClient, setSelectedClient] = useState(clientId || '');
	const [clientName, setClientName] = useState('');
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState(null);
	const isRequestSent = useRef(false);
	const matchresultId = useRef(null);
	const [mrNumber, setMrNumber] = useState('');
	const [reviewStatus, setReviewStatus] = useState('');
	const [productCriteria, setProductCriteria] = useState('');
	const [mfrCriteria, setMfrCriteria] = useState('');
	const [ctlgCriteria, setCtlgCriteria] = useState('');
	const [cardContent, setCardContent] = useState(null); // State to track card content
	const [attachments, setAttachments] = useState([]); // State to store attachments
	const [alertDetail, setAlertDetail] = useState(null);
	const [countMatched, setCountMatched] = useState(0);
	const [countUnmatched, setCountUnmatched] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const { callApi, setIsApiLoading } = useApi();
	const [finalReviewBy, setFinalReviewBy] = useState('');
	const [finalReviewTimestamp, setFinalReviewTimestamp] = useState('');
	const [activeTab, setActiveTab] = useState('Matched Item (0)');
	const [viewMode, setViewMode] = useState('table');
	const [rowdata, setRowData] = useState([]);
	const [checkedItems, setCheckedItems] = React.useState([]);
	const columns = data?.UNIQUE_COL_NAMES_NO_ID || [];
	const paginatedRows = rowdata; // Just use the data returned from API directly
	const pageGroupSize = 10;
	const [currentPage, setCurrentPage] = useState(1);
	const [searchQuery, setSearchQuery] = useState('');
	const isRequestInProgress = useRef(false);
	const [totalRecords, setTotalRecords] = useState(0);
	const [pageSize, setPageSize] = useState(20);
	const [dataType, setDataType] = useState('MATCHED_ITEMS');
	const [selected, setSelected] = useState('');
	const [selectedIds, setSelectedIds] = useState([]);
	const searchComponentRef = useRef(null);
	const [gotoPageInput, setGotoPageInput] = useState('');
	const [alertTitle, setAlertTitle] = useState('');

	const pageNumbers = [];
	const maxVisiblePages = 10;
	let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
	let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

	// Adjust start page if we're near the end
	if (endPage - startPage + 1 < maxVisiblePages && startPage > 1) {
	  startPage = Math.max(1, endPage - maxVisiblePages + 1);
	}

	for (let i = startPage; i <= endPage; i++) {
	  pageNumbers.push(i);
	}
	

	


	const handleClientChange = async (e) => {
	  const newClientId = e.target.value;
	  const selectedClientName = e.target.options[e.target.selectedIndex]?.text || '';
	  setSelectedClient(newClientId);
	  setClientName(selectedClientName);
	  setCurrentPage(1);
	  
	  fetchBigMatchResult();
	};

	async function fetchBigMatchResult() {
		      try {
		        const response = await apiFetch(`${config.API_BASE_URL}/findBigMatches`, {
		          method: 'POST',
		          headers: {
		            'Content-Type': 'application/json',
		            'X-Username': username,
		            'Authorization': `Bearer ${mrToken}`
		          },
		          body: JSON.stringify({
		            batchMatchId: batchMatchIdRef.current,
		            clientId: selectedClient
		          }),
		        });
		        if (response.ok) {
		          const result = await response.json();
		          setBigMatchResult(result.data?.bigMatchResult || null);
		        }
		      } catch (error) {
		        console.error('Error fetching big match result:', error);
		      }
		    }
	
	useEffect(() => {
	  setActiveTab(`Matched Item (${countMatched || 0})`);
	}, [countMatched]);
	// Add this useEffect at the top of your other useEffects
	useEffect(() => {
	  // Use the values from location.state when component mounts
	  if (location.state?.batchMatchId && location.state?.clientId) {
	    batchMatchIdRef.current = location.state.batchMatchId;
	    setSelectedClient(location.state.clientId);

	    console.log("Using navigation state:", {
	      batchMatchId: location.state.batchMatchId,
	      clientId: location.state.clientId
	    });
	  }
	}, [location.state]);


	// Handler for tab click
	const handleTabClick = (newDataType) => {
	  setDataType(newDataType);         // Switch tab
	  setSearchQuery("");    

	  if (searchComponentRef.current && searchComponentRef.current.clearSearch) {
	    searchComponentRef.current.clearSearch();
	  }
          // Reset search term
	  setCurrentPage(1);                // Optionally reset page
	  fetchRowData(newDataType, "", 1, pageSize); // Fetch data with cleared search
	};

	
	const getTabNameForDataType = (dataType) => {
		setDataType(dataType);
		switch (dataType) {
			
			case 'MATCHED_ITEMS': return `Matched Item (${countMatched || 0})`;
			case 'UNMATCHED_ITEMS': return `Unmatched Item (${countUnmatched || 0})`;			
			default: return `Matched Item (${countMatched.current || 0})`;
		}
	};

	const fetchFinalReview = async () => {
		    if (isRequestSent.current) return;
		    isRequestSent.current = true;
		    setLoading(true);

		    console.log("Fetching data with:", {
		      batchMatchId: batchMatchIdRef.current,
		      clientId: selectedClient
		    });
			await callApi(async () => {
			    setIsApiLoading(true);
		    try {
		      const response = await apiFetch(`${config.API_BASE_URL}/finalreview`, {
		        method: 'POST',
		        headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
		        body: JSON.stringify({
		          batchMatchId: batchMatchIdRef.current,
		          clientId: selectedClient,
				  matchResultId:matchResultId,
				  matchResultType:bigMatchResult
		        }),
		      });

		      if (response.ok) {
		        const result = await response.json();
		        console.log("Final review data:", result);
		        if (result.data) {
		          matchresultId.current = result.data.BATCH_MATCH_RESULT?.mongoId;				  
		          setMrNumber(result.data.BATCH_MATCH_RESULT?.mrNumber || '');
		          setData(result.data);
		          setReviewStatus(result.data.BATCH_MATCH_RESULT?.status || '');
				  // Set the new state values
				  setReviewStatus(result.data.BATCH_MATCH_RESULT.status);					
		          setClientName(result.data.CLIENT_NAME || '');

				  if (result.data.MATCHING_TYPE === 'BIG') {
				    setCountMatched(result.data.BIG_DRAFT_COUNT || 0);
				    setCountUnmatched(result.data.BIG_UNMATCHED_COUNT || 0);
					setBigMatchResult(result.data.MATCHING_TYPE);
				  } else if (result.data.DRAFT_BUCKET) {
				    setCountMatched(result.data.DRAFT_BUCKET.matchedCount || 0);
				    setCountUnmatched(result.data.DRAFT_BUCKET.unMatchedCount || 0);
				  } else {
				    setCountMatched(0);
				    setCountUnmatched(0);
				  }

				  //setCountMatched(result.data.DRAFT_BUCKET?.countMatched || 0);
				  //setCountUnmatched(result.data.DRAFT_BUCKET?.countUnMatched || 0);
	              setFinalReviewBy(result.data.BATCH_MATCH_RESULT.finalReviewBy);
				  setFinalReviewTimestamp(result.data.BATCH_MATCH_RESULT.finalReviewTimestamp);
		          const criteria = result.data.BATCH_MATCH_CRITERIA || {};
		          setProductCriteria(criteria.productCriteria || 'N/A');
		          setMfrCriteria(criteria.mfrCriteria || 'N/A');
		          setCtlgCriteria(criteria.ctlgCriteria || 'N/A');
				  if (matchresultId.current) {
					//fetchRowData = async (dataType, searchText = '',  pageNumber = null, pageSizeParam = pageSize) => {
					await fetchRowData('MATCHED_ITEMS', searchQuery, currentPage, pageSize);		  						
					}
		        } else {
		          console.error("Response missing data property:", result);
		        }
		      } else {
		        console.error("Response not OK:", response.status);
		        setData(null);
		      }
		    } catch (error) {
		      console.error("Error fetching final review data:", error);
		      setData(null);
		    } finally {
		      setLoading(false);
		      isRequestSent.current = false;
			  setIsApiLoading(false);
		    }
			});
		  };

	useEffect(() => {
	  
	  if (batchMatchIdRef.current && selectedClient) {
	    fetchFinalReview();
	  }
	}, [selectedClient]);

	const fetchRowData = async (dataType, searchText,  pageNumber, pageSizeParam = pageSize) => {
		// Use pageSizeParam instead of relying on the state

		setLoading(true);
		if (isRequestInProgress.current) return;
		isRequestInProgress.current = true;
		await callApi(async () => {
		setIsApiLoading(true);
		try {
			
			// Use the provided pageNumber parameter, or fall back to current state
			const pageToSend = pageNumber || currentPage;

			// Update the current page state if a page number was provided
			if (pageNumber) {
				setCurrentPage(pageNumber);
			}

			const response = await apiFetch(`${config.API_BASE_URL}/finalReviewMatchData`, {
				method: 'POST',
                headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
				body: JSON.stringify({
					matchResultId: matchresultId.current,
					clientId: selectedClient,
					batchMatchId: batchMatchId,
					dataType: dataType,
					search: searchText,
					username: sessionuser,
					pageNo: pageToSend,
					limit: pageSizeParam,
					bigMatchResult: bigMatchResult
				}),
			});
			if (response.ok) {
				const result = await response.json();
				setRowData(result.data.SEARCH_LIST || []);
				setTotalPages(Math.ceil((result.data.records || 0) / pageSizeParam));
				setTotalRecords(result.data.records || 0);
			} else {
				setRowData([]);
				setTotalRecords(0);
				
			}
		} catch (error) {
			console.error("Error fetching row data:", error);
			setRowData([]);
			
		} finally {
			setLoading(false);
			isRequestInProgress.current = false;
			setIsApiLoading(false);
		}
		});
	};
	
	// Add this useEffect to set clientName when data is first loaded
	useEffect(() => {
	  if (data?.ACTIVE_CLIENTS?.length > 0 && selectedClient) {
	    // Find the selected client in the active clients list
	    const clientObj = data.ACTIVE_CLIENTS.find(client => client.clientId === selectedClient);
	    if (clientObj) {
	      setClientName(clientObj.clientName);
	    }
	  }
	}, [data, selectedClient]);
	
	const handleViewAlertDetail = (mrNumber) => {
		setCardContent('alertDetail'); // Set content to "Alert Detail"
		setIsMinimized(false); // Ensure the card is maximized
		fetchAlertDetail(mrNumber); // Fetch alert detail data
	};

	const handleViewMatchCriteria = () => {
		setCardContent('matchCriteria'); // Set content to "Match Criteria"
		setIsMinimized(false); // Ensure the card is maximized
	};
	
	
	
	const handleBackToDraftReview = () => {
	    navigate('/matching/draftreview', { state: { batchMatchId, clientId } });
	  };
	
	const handleBackToMatchingSummary = () => {
	  if (batchMatchId) {
	    navigate('/matching/matchingsummary', {
	      state: {
	        mongoId: batchMatchId,
	        ...(mrNumber && { mrNumber }),
	        ...(alertTitle && { alertTitle })
	      }
	    });
	  } else {
	    console.error("batchMatchId is missing");
	  }
	};
	const [isMinimized, setIsMinimized] = useState(true);

	const toggleCard = () => {
		setIsMinimized((prev) => !prev);
	};
	
	const handleRowClick = (mongo_id, event) => {
	  // Prevent toggling if the click is on the checkbox itself or if text is selected
	  if (event.target.type === 'checkbox' || window.getSelection().toString()) return;
	  setCheckedItems(prev =>
	    prev.includes(mongo_id)
	      ? prev.filter(id => id !== mongo_id)
	      : [...prev, mongo_id]
	  );
	};

	const fetchAlertDetail = async (mrNumber) => {
		try {
			if (typeof mrNumber !== 'string' || !mrNumber.trim()) {
				console.error('Invalid MR Number:', mrNumber);
				return;
			}

			const requestBody = { mrNumber };

			const response = await apiFetch(`${config.API_BASE_URL}/alertdetail`, {
				method: 'POST',
                headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
				body: JSON.stringify(requestBody),
			});

			if (response.ok) {
				const data = await response.json();
				setAlertDetail(data?.data?.SUPPORT_ALERT || null);
				setAlertTitle(data?.data?.SUPPORT_ALERT.alertTitle || null); // Populate alertDetail state
				setAttachments(data?.data?.ATTACHMENT_LIST || []); // Populate attachments state
			} else {
				console.error('Failed to fetch alert detail:', response.statusText);
				setAlertDetail(null);
				setAttachments([]);
			}
		} catch (error) {
			console.error('Error fetching alert detail:', error);
			setAlertDetail(null);
			setAttachments([]);
		}
	};
	
	const selectAllCheckboxChange = (isChecked) => {
		if (isChecked) {
			const allItemIds = rowdata.map((row) => row.mongo_id);
			setCheckedItems(allItemIds);
		} else {
			setCheckedItems([]);
		}
	};

	const handleCheckboxChange = (id, isChecked) => {
	    setCheckedItems((prev) =>
	        isChecked
	            ? prev.includes(id) ? prev : [...prev, id]
	            : prev.filter((item) => item !== id)
	    );
	};

	const handleGotoPage = () => {
	  const page = Number(gotoPageInput);
	  if (!page || page < 1 || page > totalPages) {
	    PopupService.getInstance().showMessage('Entered page number not valid', false);
	    return;
	  }
	  setCurrentPage(page);
	  fetchRowData(dataType, searchQuery, page, pageSize);
	};


	async function handleSaveFinalizeFinalReview(batchMatchId, clientId, username, mrToken, mrNumber, PopupService) {
	    try {
			
	        const validateResponse = await apiFetch(`${config.API_BASE_URL}/validateFinalReview`, {
	            method: 'POST',
	            headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
	            body: JSON.stringify({ batchMatchId, clientId })
	        });

	        const validateResult = await validateResponse.json();

	        if (validateResult.DRAFT_COMPLETED === 'NO'){
				PopupService.getInstance().showMessage(`Draft review not completed: Please complete draft first and then save final review`, false);
				return;
			}else 	if (validateResult.exists) {
	            const confirm = await PopupService.getInstance().showConfirm(
	                `A Final review already exists for this client: ${clientId} and MR Number: ${mrNumber}, do you want to create another Final Review file?`
	            );
	            if (!confirm) return;
			}
			
	        const saveResponse = await apiFetch(`${config.API_BASE_URL}/saveFinalReview`, {
	            method: 'POST',
	            headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
	            body: JSON.stringify({ batchMatchId, clientId, username })
	        });

	        if (saveResponse.ok) {
				PopupService.getInstance().showMessage('Final Review saved successfully', true);
	            
	        } else {
	            const error = await saveResponse.text();
				PopupService.getInstance().showMessage(`Failed to save Final Review: ${error}`, false);
	        }
	    } catch (err) {
	        PopupService.getInstance().showMessage(`Error: ${err.message}`, false);
	    }
	}

	const handleMovetToUnmatched = async (action) => {        
	    let addUrl = 'moveItemsToUnmatchedForFinal';
	    let selectedValue = selected; // default to current state

	    if (action === 'selected') {
	        if (checkedItems.length === 0) {
	            alert('No items selected');
	            return;
	        }
	        selectedValue = 'selected';
	    } else if (action === 'all') {
	        selectedValue = 'all';
	        alert(selectedValue);
	    }
	  await callApi(async () => {
	          setIsApiLoading(true);
	    try {
	        const response = await apiFetch(`${config.API_BASE_URL}/${addUrl}`, {
	            method: 'POST',
	            headers: {
	                'Content-Type': 'application/json',
	                'X-Username': username,
	                'Authorization': `Bearer ${mrToken}`
	            },
	            body: JSON.stringify({
	                batchMatchId,
	                clientId,
	                username,
	                matchIds: checkedItems,
	                selected: selectedValue,
					bigMatchResult: bigMatchResult,
					matchresultId: matchresultId,
					batchMatchId:batchMatchId,
					clientId:selectedClient
	            }),
	        });
	        if (response.ok) {
	            const result = await response.json();
	            setCheckedItems([]);
	            PopupService.getInstance().showMessage(result.message, true, 3000);
				await fetchFinalReview();
	        } else {
	            alert(`Failed to add ${action === 'selected' ? 'selected items' : 'all items'} to bucket`);
	        }
	    } catch (error) {
	        console.error(`Error adding ${action === 'selected' ? 'selected items' : 'all items'} to bucket:`, error);
	    }finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	    });
	};
	
	 const handleMovetToMatched = async (action) => {        
	     let addUrl = 'moveItemsToMatchedForFinal';
	     let selectedValue = selected; // default to current state

	     if (action === 'selected') {
	         if (checkedItems.length === 0) {
	             alert('No items selected');
	             return;
	         }
	         selectedValue = 'selected';
	     } else if (action === 'all') {
	         selectedValue = 'all';
	         alert(selectedValue);
	     }
	   await callApi(async () => {
	   setIsApiLoading(true);
	     try {
	         const response = await apiFetch(`${config.API_BASE_URL}/${addUrl}`, {
	             method: 'POST',
	             headers: {
	                 'Content-Type': 'application/json',
	                 'X-Username': username,
	                 'Authorization': `Bearer ${mrToken}`
	             },
	             body: JSON.stringify({
	                 batchMatchId:batchMatchId,
	                 clientId:selectedClient,
	                 username:username,
	                 matchIds: checkedItems,
	                 selected: selectedValue,
					 bigMatchResult:bigMatchResult,
			
					 matchResultId: matchresultId.current
	             }),
	         });
	         if (response.ok) {
	             const result = await response.json();
	             setCheckedItems([]);
	             PopupService.getInstance().showMessage(result.message, true, 3000);
				 await fetchFinalReview();
	         } else {
	             alert(`Failed to add ${action === 'selected' ? 'selected items' : 'all items'} to bucket`);
	         }
	     } catch (error) {
	         console.error(`Error adding ${action === 'selected' ? 'selected items' : 'all items'} to bucket:`, error);
	   }finally {
	       setLoading(false);
	       setIsApiLoading(false);
	     }
	     });
	 };
	return (
		<>
			<Header />
			<div className="container-fluid text-secondary">
				<br /><br /><br /><br />
				<div className="container-fluid no-margin no-padding text-secondary">
					<div className="card text-secondary">

					<div className="card-header">
					  Final Review {clientName ? `- ${clientName} (${selectedClient})` : ''} {mrNumber ? `- ${mrNumber}` : ''}
					</div>

						
						<div className='card-body custom-card-bg'>
							<div className="card text-secondary">
								<div className="card-header">Matching Details</div>
								<div className="card-body">
								{loading ? (
									<div>Loading...</div>
								) : (
									<>
									<div className="row">
											<div className="col-md-4">
												<label htmlFor="clientDropdown" className="form-label me-3">Select Client:</label>
												<div className="col-md-11 me-3">
													<select
														id="clientDropdown"
														className="form-select"
														value={selectedClient}
														onChange={handleClientChange}
													>
														<option value="">-- Select Client --</option>
														{data?.ACTIVE_CLIENTS?.map((client, idx) => (
															<option
																key={client.mongoId || idx}
																value={String(client.clientId)} 
															>
																{client.clientId} - {client.clientName}
															</option>
														))}
													</select>
												</div>
										   
												</div>
												<div className="col-md-3">
												 <label htmlFor="clientDropdown" className="form-label me-3">Match Status:</label>
												 <br/>
												 {reviewStatus === 'DRAFT_REVIEW_DONE' ? (
													<>
												   <span className="badge bg-success">
												   <i className='fa fa-check'></i>&nbsp;&nbsp;
												   {reviewStatus}</span>
												   <br/>
												   Matched Count: {countMatched} <br/>Unmatched Count: {countUnmatched}
												   </>
												   ) : (
													<>
													<span className="badge bg-danger">
												   
												   {reviewStatus}</span>
												   
												   {/*<br/>Draft Review - Pending*/}
												   </>
												 )}
												 </div>  
									</div>
									<br />
										<div className="row">
											<div className="col-md-12 mb-3">
												<div className="d-flex justify-content-start">

													<button
														className="btn btn-info btn-sm text-light"
														onClick={() => handleViewAlertDetail(mrNumber)} // Pass mrNumber as a parameter
													>
														View Alert Detail
													</button>

													<button
														className="btn btn-info btn-sm text-light ms-2"
														onClick={handleViewMatchCriteria}
													>
														View Match Criteria
													</button>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-md-6">
											<div className="card text-secondary">
												<div className="card-header d-flex justify-content-between align-items-center">
													<span>Match Review Detail</span>
													<button
														className="btn btn-sm btn-link text-secondary"
														onClick={() => setIsMinimized((prev) => !prev)} // Toggle using existing setIsMinimized
														style={{ textDecoration: 'none' }}
													>
														<i className={isMinimized ? "fa fa-plus" : "fa fa-minus"}></i>
													</button>
												</div>
											
											{!isMinimized && ( // Conditionally render the card body
												<div className="card-body">
												<div className="row">
													<div className="col-md-12">												
													<ul className="list-group">
														<li className="list-group-item text-secondary">
															<span className="text-primary">Review Status:</span> {reviewStatus}
														</li>
														{['FINAL_REVIEW_DONE'].includes(reviewStatus) && (
															<>
																<li className="list-group-item text-secondary">
																	<span className="text-primary">Final Review Timestamp:</span> {finalReviewTimestamp}
																</li>
																<li className="list-group-item text-secondary">
																	<span className="text-primary">Final Review By:</span> {finalReviewBy}
																</li>
																
															</>
														)}
													</ul>
												    </div>
												</div>
												</div>												
											)}
											</div>													
											</div>
											<div className="col-md-6">
											{cardContent && (
												<div className="card text-secondary">
													<div className="card-header d-flex justify-content-between align-items-center">
														<span>
															{cardContent === 'alertDetail' && `Alert Detail - ${alertDetail?.mrNumber || ''}`}
															{cardContent === 'matchCriteria' && 'Match Criteria'}
															{!cardContent && 'Card Title'}
														</span>
														<button
															className="btn btn-sm btn-link text-secondary"
															onClick={toggleCard}
															style={{ textDecoration: 'none' }}
														>
															<i className={isMinimized ? "fa fa-plus" : "fa fa-minus"}></i>
														</button>
													</div>	
													{!isMinimized && (
														<div className="card-body">
														{cardContent === 'alertDetail' && ( alertDetail ? (
															<div className="row mt-3">																
																<div className="col-md-6">	
																	<ul className="list-group">
																		<li className="list-group-item active">Alert Detail</li>
																		<li className="list-group-item text-secondary"><strong>Title:</strong> {alertDetail.alertTitle}</li>
																		<li className="list-group-item text-secondary"><strong>Class:</strong> {alertDetail.alertClass}</li>
																		<li className="list-group-item text-secondary"><strong>Source:</strong> {alertDetail.alertSource}</li>
																		<li className="list-group-item text-secondary"><strong>Type:</strong> {alertDetail.alertType}</li>
																		<li className="list-group-item text-secondary"><strong>Manufacturer:</strong> {alertDetail.manufacturer}</li>
																		<li className="list-group-item text-secondary"><strong>Product Desc:</strong> <span dangerouslySetInnerHTML={{ __html: alertDetail.productDesc }} /></li>
																		<li className="list-group-item text-secondary"><strong>Reason:</strong> <span dangerouslySetInnerHTML={{ __html: alertDetail.reason }} /></li>
																	</ul>
																</div>
																<div className="col-md-6">
																	{attachments && attachments.length > 0 ? (
																		<div>

																			<ul className="list-group">
																				<li className="list-group-item active">Attachments</li>
																				{attachments.map((file, idx) => (
																					<li className="list-group-item text-secondary" key={idx}>
																						<span className="text-primary">{file.clientId}</span>&nbsp;-&nbsp;
																						<a
																							href={`${config.API_BASE_URL}/attachment_download/${file.mongoId}`}
																							target="_blank"
																							rel="noopener noreferrer"
																							download={file.fileName}
																						>
																							{file.fileName}
																						</a>
																					</li>
																				))}
																			</ul>
																		</div>
																	) : (
																		<p>No attachments available.</p>
																	)}
																</div>																		
																</div>
																	
																) : (
																	<p>No alert detail available.</p>
																)
																
																
															)}
															{cardContent === 'matchCriteria' && <div className="row mt-3">
																<div className="col-md-6">
																	<div class="alert alert-primary" role="alert">
																		<strong>Product Criteria:</strong> {productCriteria}
																	</div>
																	<div class="alert alert-warning" role="alert">
																		<strong>Manufacturer Criteria:</strong> {mfrCriteria}
																	</div>
																</div>
																<div className="col-md-6">
																	<div class="alert alert-danger" role="alert">
																		<strong>Catalog Criteria:</strong> {ctlgCriteria}
																	</div>
																</div>
															</div>}
														</div>	
													)}												
											   </div>		
											)}
											
											</div>
										  
										</div>
									</>
									)}																			
								</div>
							</div>
							<br />
							<div className="card text-secondary">

							<div className="card-header d-flex justify-content-between align-items-center">
							  <span>
							    Final Review - {clientName} ({selectedClient}) - {mrNumber}
							  </span>
							  <div>
							    <button
							      className="btn btn-secondary btn-sm text-light ms-2"
							      onClick={handleBackToMatchingSummary}
							    >
							      Back To Matching Summary
							    </button>
							    <button
							      className="btn btn-secondary btn-sm text-light ms-2"
							      onClick={handleBackToDraftReview}
							    >
							      Back To Draft Review
							    </button>
							  </div>
							</div>

								<div className="card-body">
								<div className="mb-3">
										<ul className="nav nav-tabs">
											{[
												{ tabName: `Matched Item (${countMatched || 0})`, dataType: 'MATCHED_ITEMS' },
												{ tabName: `Unmatched Item (${countUnmatched || 0})`, dataType: 'UNMATCHED_ITEMS' },
												
											].map(({ tabName, dataType: dataType }) => (
												<li className="nav-item" key={dataType}>

													<button

													className={`nav-link ${activeTab === tabName ? 'active' : 'text-secondary'}`}

														onClick={() => {
															setActiveTab(tabName);
															handleTabClick(dataType);  // Call only handleTabClick which will handle all the logic
														}}
													>
														{tabName}
													</button>

												</li>
											))}
										</ul>
									</div>
									<div className="d-flex align-items-center flex-wrap gap-2 mb-3">
									{activeTab.includes('Matched Item') && (
									<div className="btn-group btn btn-sm">
											<button
												type="button"
												className="btn btn-primary btn-sm dropdown-toggle text-light"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												Move To Unmatched
											</button>
											<ul className="dropdown-menu">
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleMovetToUnmatched('selected')}
													>
														Move Selected Items To Unmatched
													</button>
												</li>
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleMovetToUnmatched('all')}
													>
														Move All Items To Unmatched
													</button>
												</li>
											</ul>
										</div>
										)}
										{activeTab.includes('Unmatched Item') && (
										<div className="btn-group btn btn-sm">
											<button
												type="button"
												className="btn btn-danger btn-sm dropdown-toggle text-light"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												Move To Matched
											</button>
											<ul className="dropdown-menu">
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleMovetToMatched('selected')}
													>
														Move Selected Items To Matched
													</button>
												</li>
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleMovetToMatched('all')}
													>
														Move All Items To Matched
													</button>
												</li>
											</ul>
										</div>
										)}
										<div className="btn-group btn btn-sm">
										<button
											type="button"
											className="btn btn-sm btn-success text-light"										
											aria-expanded="false"
											onClick={() =>
											    handleSaveFinalizeFinalReview(batchMatchId, selectedClient, username, mrToken, mrNumber, PopupService)
											  }
										>
											Save & Finalize
										</button>																														
									</div>
									
									   <div className="ms-auto d-flex align-items-center gap-2">
									  
									<select
										id="pageSizeDropdown"
										className="form-select"
										value={pageSize}
										onChange={(e) => {
											const newPageSize = Number(e.target.value);
											setPageSize(newPageSize); // Update the page size state
											setCurrentPage(0); // Reset to the first page

											// Use the newPageSize directly in the fetchRowData call
											fetchRowData(dataType, searchQuery, 1,  newPageSize);
										}}
										style={{ maxWidth: '150px' }}
									    >
										<option value={20}>20</option>
										<option value={50}>50</option>
										<option value={100}>100</option>
									</select>
									&nbsp;
									
										<SearchComponent
										    ref={searchComponentRef}
											viewMode={viewMode}
											toggleViewMode={() => setViewMode(viewMode === 'table' ? 'card' : 'table')}
											onSearch={(searchText) => {
												setCurrentPage(0);
												setSearchQuery(searchText); // Update the search query state
												fetchRowData(dataType, searchText, 1,  pageSize);
											}}
										/>
									</div>	
									</div>								
							
															
								{loading ? (
								  <div>Loading...</div>
									) : (
										viewMode === 'table' ? (
											<div className="table-responsive">
												<div>
													<table className="table table-responsive-sm text-secondary table-bordered table-striped table-sm">
														<thead>
															<tr>
																<th>
																	<input
																		type="checkbox"
																		id="selectAllCheckbox"
																		onChange={(e) => selectAllCheckboxChange(e.target.checked)}
																		checked={checkedItems.length === rowdata.length && rowdata.length > 0}
																	/>
																</th>
																<th>#</th>
																{columns.map((col, idx) => (
																	<th key={idx}>{col.val1}</th>
																))}
															</tr>
														</thead>
														<tbody>
															{paginatedRows.length === 0 ? (
																<tr className='table-danger'>
																	<td colSpan={columns.length + 2} className="text-center table-danger">No data found</td>
																</tr>
															) : (
																paginatedRows.map((row, rowIdx) => (
																	<tr
								                                        key={row.mongo_id || rowIdx}
																		className={
																		  row.st_selected === 'YES'
																		    ? (activeTab.includes('Unmatched Item') ? 'table-danger' : 'table-success')
																		    : ''
																		}
								                                        onClick={event => handleRowClick(row.mongo_id, event)}
								                                        style={{ cursor: 'pointer' }}
								                                      >
																		<td>
																			<input
																				type="checkbox"
																				id={row.mongo_id}
																				value={row.mongo_id}
																				onChange={(e) =>
																					handleCheckboxChange(row.mongo_id, e.target.checked)
																				}
																				checked={checkedItems.includes(row.mongo_id)}
																			/>
																		</td>
																		
																		<td>{(currentPage - 1) * pageSize + rowIdx + 1}</td>
																		{columns.map((col, colIdx) => (
																			<td
																				key={colIdx}
																				dangerouslySetInnerHTML={{ __html: row[col.val1] || row[col.key] || '-' }}
																				className="text-nowrap"
																			/>
																		))}
																	</tr>
																))
															)}
														</tbody>
													</table>
												</div>
											</div>
										) : (

											<div className="row">
												{paginatedRows.map((row, rowIndex) => (
													<div className="col-md-4 mb-3" key={rowIndex}>
														<div className="card">
															<div className="card-body">
																<ul className="list-group">
																	<li
																		className={`list-group-item  list-group-item-secondary`}
																	>
																		#&nbsp;{(currentPage - 1) * pageSize + rowIndex + 1}&nbsp;-&nbsp;
																		<input
																			type="checkbox"
																			id={row.mongo_id}
																			value={row.mongo_id}
																			onChange={(e) =>
																				handleCheckboxChange(row.mongo_id, e.target.checked)
																			}
																			checked={checkedItems.includes(row.mongo_id)}
																		/> Select
																	</li>
																	{columns.map((col, colIndex) => (
																		<li
																			key={colIndex}
																			className={`list-group-item  ${row.st_selected === 'YES' ? 'light-yellow' : ''}`}
																		>
																			<strong>{col.displayName || col.val1}:</strong>{' '}
																			<span dangerouslySetInnerHTML={{ __html: row[col.val1] || row[col.key] || '-' }} />
																		</li>
																	))}
																</ul>
															</div>
														</div>
													</div>
												))}
											</div>

										)
									)}
									
									{paginatedRows.length > 0 && (
											<div className="d-flex justify-content-between align-items-center mt-3">

												<nav>
													<ul className="pagination mb-0">
														<li className={`page-item${currentPage === 0 ? ' disabled' : ''}`}>
															<button
																className="page-link text-secondary"
																onClick={() => fetchRowData(dataType,  searchQuery,  1, pageSize)}
																disabled={currentPage === 1}
															>
																First
															</button>
														</li>
														<li className={`page-item${currentPage === 0 ? ' disabled' : ''}`}>
															<button
																className="page-link text-secondary"
																onClick={() => fetchRowData(dataType,  searchQuery,  currentPage, pageSize)}
																disabled={currentPage === 1}
															>
																Previous
															</button>
														</li>
														{pageNumbers.map((page) => (
															<li key={page} className={`page-item${currentPage === page  ? ' active' : ''}`}>
																<button
																	className={`page-link ${currentPage === page ? 'text-light' : 'text-secondary'}`}
																	onClick={() => fetchRowData(dataType,  searchQuery,  page, pageSize)}
																	
																>
																	{page}
																</button>
															</li>
														))}
														<li className={`page-item${currentPage === totalPages  ? ' disabled' : ''}`}>
															<button
																className="page-link text-secondary"
																onClick={() => fetchRowData(dataType,  searchQuery,  currentPage, pageSize)}
																disabled={currentPage === totalPages}
															>
																Next
															</button>
														</li>
														<li className={`page-item${currentPage === totalPages  ? ' disabled' : ''}`}>
															<button
																className="page-link text-secondary rounded-end"
																onClick={() => fetchRowData(dataType,  searchQuery,  totalPages, pageSize)}
																disabled={currentPage === totalPages}
															>
																Last
															</button>
														</li>
														<li>
						                                    <div className="d-flex align-items-center">
						                                             &nbsp;  &nbsp; 
				                                                <input
				                                                 type="number"
				                                                 min="1"
				                                                 max={totalPages}
				                                                 value={gotoPageInput}
				                                                 onChange={e => setGotoPageInput(e.target.value)}
				                                                 onKeyDown={e => {
				                                                     if (e.key === 'Enter') {
				                                                       handleGotoPage();
				                                                     }
				                                                   }}
				                                                 className="form-control"
				                                                 style={{ width: 100, marginRight: 4 }}
				                                                 placeholder="Page #"
				                                                 aria-label="Go to page"
				                                               />
				                                               <button
				                                                 className="btn btn-secondary btn"
				                                                 onClick={handleGotoPage}
				                                                 type="button"
				                                                 style={{ marginRight: 8 }}
				                                               >
				                                                 Go
				                                               </button>
						                                    </div>
						                               </li>
													</ul>
												</nav>

												<span className="text-secondary">
													Page {currentPage} of {totalPages} | Total Records: {totalRecords}
												</span>
											</div>
										)}
									</div>
							</div>	
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default FinalReview;